import React from 'react';
import styled from 'styled-components';

const Logo = styled.div<any>`
  align-vertical: -4px;
  width: 105px;
  height: 31px;
  color: #ffffff;
`;

const VeritixLogo = ({ width = "105px", height = "31px"}) => {
  return (
    <Logo width={width} height={height}>
      <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 136 40">
        <title>Veritix</title>
          <defs>
              <path id="a" d="M0 38h127.712V.953H0z"/>
          </defs>
          <g fill="none" fillRule="evenodd">
              <path fill="#FFF" d="M118.805 11.331l-1.232 2.079 3.882 7.548 8.257-9.627zM105.456 11.331h-2.907l9.507 11.389-6.251 10.548h5.092l5.05-5.887 8.904 10.666h2.488l-.672-1.307-7.03-13.663-3.621-7.041-2.421-4.705zM18.596 11.331l-4.698 13.247-4.897-13.247H2l8.723 21.349.094.233h6.141l8.378-21.582z"/>
              <g transform="translate(2 .047)">
                  <path fill="#FFF" d="M37.041 19.33h-7.543c.22-1.228 1.077-2.431 2.453-3.004a4.578 4.578 0 0 1 1.781-.353c2.827 0 4.033 1.668 4.25 3.356h-.941zm-1.638-8.56a13.794 13.794 0 0 0-1.756-.12c-5.221 0-10.622 4.242-10.622 11.341 0 7.558 5.599 11.511 11.13 11.511 5.281 0 8.318-2.977 9.544-6.029l-5.51-1.639c-.168.29-.359.55-.574.779-.81.864-1.948 1.313-3.417 1.313-2.124 0-3.874-1.206-4.559-2.958a4.412 4.412 0 0 1-.282-1.035h14.496l.177-.003.186-.003.023-.53c.024-.313.073-.957.073-1.575 0-6.252-3.373-10.345-8.909-11.051zM59.606 11.116c-1.486 0-3.983.329-5.552 2.307v-2.138h-6.212v21.582h6.382v-9.901c0-3.657 1.683-5.511 5.001-5.511.554 0 1.068.052 1.62.162l.448.089v-6.471l-.337-.033c-.425-.042-.865-.086-1.35-.086"/>
                  <mask id="b" fill="#fff">
                      <use xlinkHref="#a"/>
                  </mask>
                  <path fill="#FFF" d="M64.527 32.867h6.381V11.285h-6.381zM67.696.954c-2.12 0-3.847 1.745-3.847 3.89 0 2.061 1.762 3.804 3.847 3.804 2.121 0 3.847-1.707 3.847-3.804 0-2.182-1.69-3.89-3.847-3.89M84.045 5.06h-5.831v3.298c0 .88-.277 2.927-2.843 2.927h-1.433v5.746h3.768v9.32c0 4.202 2.675 6.813 6.98 6.813 1.674 0 2.73-.292 3.32-.537l.23-.096v-5.406l-.477.137c-.255.073-.988.154-1.633.154-1.536 0-2.081-.533-2.081-2.038V17.03h4.192v-5.746h-4.192V5.06zM92.341 32.867h6.381V11.285h-6.381zM95.51.954c-2.121 0-3.847 1.745-3.847 3.89 0 2.061 1.762 3.804 3.847 3.804 2.12 0 3.847-1.707 3.847-3.804 0-2.182-1.69-3.89-3.847-3.89" mask="url(#b)"/>
              </g>
          </g>
      </svg>
    </Logo>
  )
}

export default VeritixLogo;
